<script>
import * as Mock from '@/tests/__mocks__/composicaoFundo'
import ShowComposition from '@components/show-composition'
import moment from 'moment'
import Vue from 'vue'
import { MODAL } from '@constants/Text'
import AtivoShort from '@modal/pesquisa-ativo-short'
import AtivoLong from '@modal/pesquisa-ativo-long'
import EditarAtivo from '@modal/simulador-editar-ativo'
import { getUnique, getNumber, toPercent } from '@utils/Format'
import apiComposicaoFundos from '../api/settings/composicaoFundos'

export default {
  components: { AtivoShort, AtivoLong, EditarAtivo, ShowComposition },
  props: {
    podeEditar: {
      type: Boolean,
      default: false,
    },
    ativo: {
      type: Object,
      default: 0,
    },
  },
  data() {
    return {
      toPercent,
      bus: new Vue(),
      loading: false,
      headers: [
        {
          text: 'Ativo',
          value: 'nome_ativo',
          width: 500,
        },
        {
          text: 'Classe',
          value: 'classe',
        },
        {
          text: 'Subclasse',
          value: 'subclasse',
        },
        {
          text: 'Tipo',
          value: 'tipo',
        },
        {
          text: 'Alocação',
          value: 'alocacao_percentual',
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
          width: 120,
        },
      ],
      ativos: [],
      opcoesAgrupamento: [
        { text: 'Classe', value: 'classe' },
        { text: 'Subclasse', value: 'subclasse' },
        { text: 'Tipo', value: 'tipo' },
      ],
      agruparPor: 'classe',
      textFilter: '',
      editar: false,
    }
  },
  computed: {
    dadosGrafico() {
      const aux = {}
      let total = 0
      this.ativos.forEach((item, index) => {
        if (!aux[item[this.agruparPor]]) {
          aux[item[this.agruparPor]] = {
            name: item[this.agruparPor],
            color: this.getClassColor(item[this.agruparPor], index),
          }
        }
        aux[item[this.agruparPor]].percent =
          (aux[item[this.agruparPor]].percent || 0) + item.alocacao_percentual
        total += item.alocacao_percentual
      })
      if (total < 100) {
        aux['Não alocado'] = {
          name: 'Não alocado',
          color: '#C7BBC9',
          percent: 100 - total,
        }
      }
      return aux
    },
    percentTotal() {
      let total = 0
      this.ativos.forEach((item) => {
        total += item.alocacao_percentual
      })
      return Math.round10(total, -2)
    },
    dataReferencia() {
      return this.ativos[0] && moment(this.ativos[0].data_atualizacao).isValid()
        ? moment(this.ativos[0].data_atualizacao).format('DD/MM/YYYY')
        : '-'
    },
    podeSalvar() {
      return this.percentTotal === 100
    },
  },
  watch: {
    ativo: {
      handler: function(newVal) {
        this.carregarComposicao(newVal)
      },
      deep: true,
    },
  },
  created() {
    this.bus.$on('select-assets', this.selecionarAtivos)

    this.carregarComposicao(this.ativo)
  },
  methods: {
    getClassColor(classe, index) {
      return this.$store.getters['parameters/classColor'](classe, index)
    },
    async save() {
      if (!this.ativos.length) {
        this.$showSnack({
          text: 'Inclua ao menos um ativo.',
          button: true,
        })
        return
      }
      if (this.percentTotal === 100) {
        this.loading = true
        const lista = JSON.parse(JSON.stringify(this.ativos))
        const r = await apiComposicaoFundos.salvar({
          lista,
          id_ativo: this.ativo.id_ativo,
        })
        this.$showSnack({
          text: r.message,
          button: true,
        })
        this.loading = false
        if (r.status === 200) {
          this.carregarComposicao(this.ativo)
        }
      } else {
        this.$showSnack({
          text: 'A alocação deve ser 100%',
          button: true,
        })
      }
    },
    async carregarComposicao({ id_ativo }) {
      if (
        (!id_ativo && !this.ativo.id_ativo) ||
        (id_ativo || this.ativo.id_ativo) <= 0
      ) {
        console.log('Sem ativo informado')
        return
      }
      if (this.loading) {
        return
      }
      this.loading = true
      const r = await apiComposicaoFundos.carregar({
        id_ativo: id_ativo || this.ativo.id_ativo,
      })
      this.ativos = r.value || []
      this.loading = false
    },
    abrirSelecionarAtivo() {
      this.bus.$emit(MODAL.SEARCH_ASSET_SHORT, {
        modo: '%',
        showSubclass: true,
        hideAlerts: true,
      })
    },
    selecionarAtivos(a) {
      console.log('Ativos selecionados', a)
      const aux = [...this.ativos, ...a]
      this.ativos = getUnique(aux, 'nome_ativo')
      this.ativos = this.ativos.map((asset) => {
        asset.alocacao_percentual = getNumber(asset.percentual)
        return asset
      })
    },
    unFixAsset(asset) {
      asset.percentual = 0
      this.ativos = this.ativos.filter((a) => {
        return a.nome_ativo != asset.nome_ativo
      })
    },
    close() {
      this.$emit('close', true)
    },
    openEdit(asset) {
      asset.percentual = asset.alocacao_percentual
      this.bus.$emit(
        MODAL.SIMULATOR_EDIT_ASSET,
        { ...asset },
        {
          modo: '%',
          openClass: false,
          showSubclass: true,
          hideAlerts: true,
          callback: (a) => {
            const index = this.ativos.findIndex((a) => {
              return a.nome_ativo === asset.nome_ativo
            })
            this.$set(a, 'alocacao_percentual', getNumber(a.percentual))
            if (index >= 0) {
              this.$set(this.ativos, index, a)
            } else {
              this.$showSnack({
                text: 'Ativo não encontrado, tente novamente mais tarde.',
                button: true,
              })
            }
          },
        }
      )
    },
  },
}
</script>

<template>
  <div>
    <div v-if="!loading">
      <div>
        <div class="row">
          <div class="col-4">
            <v-row>
              <v-col cols="6">
                <small class="text-secondary">
                  Ativo
                </small>
                <p class="mb-0">
                  {{ ativo.nome_ativo || '—' }}
                </p>
              </v-col>
              <v-col cols="6">
                <small class="text-secondary">
                  Classe
                </small>
                <p class="mb-0">
                  {{ ativo.classe || ativo.CI || '-' }}
                </p>
              </v-col>
              <v-col v-if="ativo.subclasse" cols="6">
                <small class="text-secondary">
                  Subclasse
                </small>
                <p class="mb-0">
                  {{ ativo.subclasse }}
                </p>
              </v-col>
              <v-col cols="6">
                <small class="text-secondary">
                  Tipo
                </small>
                <p class="mb-0">
                  {{ ativo.tipo || ativo.Tipo || '-' }}
                </p>
              </v-col>
              <v-col v-if="ativos.length" cols="6">
                <small class="text-secondary">
                  Quantidade de ativos
                </small>
                <p class="mb-0">
                  {{ ativos.length }} ativo{{ ativos.length > 1 ? `s` : '' }}
                </p>
              </v-col>
              <v-col cols="6">
                <small class="text-secondary">
                  Data de atualização
                </small>
                <p class="mb-0"> {{ dataReferencia }} </p>
              </v-col>
            </v-row>
          </div>
          <div class="col-8" style="height: 300px;">
            <ShowComposition v-if="ativos.length" :values="dadosGrafico" center-text />
            <div
              v-if="!ativos.length"
              class="d-flex align-items-center justify-content-center"
              style="height: 100%;"
            >
              <p class="text-bold">
                Nenhum ativo adicionado na composição do ativo.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="ativos.length">
        <div class="d-flex align-items-center">
          <v-select
            v-model="agruparPor"
            :items="opcoesAgrupamento"
            label="Agrupar por"
            style="max-width: 150px;"
            hide-details
          />
          <v-spacer />
          <div class="mr-3">
            <small class="text-secondary">
              Total alocado:
            </small>
            <p
              class="mb-0 text-bold"
              :class="{ 'text-danger': percentTotal !== 100 }"
            >
              {{ toPercent(percentTotal) }}
            </p>
          </div>
          <v-text-field
            v-model="textFilter"
            placeholder="Pesquisar"
            filled
            append-icon="mdi-magnify"
            class="align-icon-search"
            hide-details
            style="max-width: 250px;"
          />
        </div>
        <v-data-table
          :items="ativos"
          :headers="headers"
          :height="300"
          fixed-header
          :group-by="agruparPor"
          :search="textFilter"
          class="mt-2"
          style="background: transparent;"
        >
          <template v-slot:item.alocacao_percentual="{ item }">
            <div>
              {{ toPercent(item.alocacao_percentual) }}
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <div v-if="podeEditar" class="d-flex">
              <v-btn icon small @click="openEdit(item)">
                <v-icon small color="primary"> mdi-pencil </v-icon>
              </v-btn>
              <v-btn icon small @click="unFixAsset(item)">
                <v-icon small color="red"> mdi-close </v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </div>
      <div v-if="podeEditar" class="d-flex">
        <v-spacer />
        <BaseButton underlined @click="close">
          Cancelar
        </BaseButton>
        <BaseButton outline primary @click="abrirSelecionarAtivo">
          Incluir ativo
        </BaseButton>
        <BaseButton
          v-if="ativos.length"
          :primary="podeSalvar"
          :secondary="!podeSalvar"
          @click="save"
        >
          Salvar
        </BaseButton>
        <v-spacer />
      </div>
    </div>
    <div
      v-if="loading"
      class="d-flex align-items-center justify-content-center"
      style="height: 40vh;"
    >
      <v-progress-circular indeterminate color="primary" size="48" />
    </div>

    <AtivoShort :bus="bus" :fixados="ativos" />
    <AtivoLong :bus="bus" :fixados="ativos" />
    <EditarAtivo :bus="bus" />
  </div>
</template>
